export default __webpack_public_path__ + "static/media/stat1.69b2c70f.png";